export default __webpack_public_path__ + "static/media/address.f1049f7e.jpg";